<template>
    <div class="">
        <div class="col-12 mb-4" v-if="attendees.length > 0">
            <h4 class="font-weight-bold">Current Registered Attendees </h4>
            <div class="py-2">
                <div class="d-flex py-1 border-bottom">
                    <p class="col-1 mb-0 text-bold"><i class="fa fa-1x fa-map-marker-alt" aria-hidden="true"></i></p>
                    <p class="col-3 mb-0 text-bold">Name</p>
                    <p class="col-3 mb-0 text-bold">Email</p>
                    <p class="col-3 mb-0 text-bold text-right">Registered</p>
                    <p class="col-2 mb-0 text-bold text-center" v-if="allowUpdates">Update</p>
                </div>
                <div v-for="attendee in attendees">
                    <div class="d-flex py-1 my-1 current">
                    <p class="col-1 mb-0 text-bold">{{attendee.location === 'oh' ? 'OH' : attendee.location === 'tx'? 'TX' : 'CO'}}</p>
                    <p class="col-3 mb-0">{{attendee.prefix}} {{attendee.first_name}} {{attendee.last_name}} {{attendee.suffix}}</p>
                    <p class="col-3 mb-0">{{attendee.email}}</p>
                    <p class="col-3 mb-0 text-right">{{attendee.created_at | formatDate}}</p>
                    <div class="col-2 my-auto text-center" v-if="allowUpdates">
                        <a data-toggle="collapse" :href="'#attendeeEdit'+attendee.id" class="text-white text-center collapsed">
                            <i class="fa fa-1x fa-edit edit"></i>
                            <i class="fa fa-1x fa-times-circle closer"></i>
                        </a>
                    </div>
                    </div>
                    <div class="col-12 collapse mt-2" :id="'attendeeEdit'+attendee.id">
                        <edit-attendee-component :attendee="attendee" :doh-available="ohAvailable" :tx-available="txAvailable" :co-available="coAvailable" :sponsorship="sponsorship"></edit-attendee-component>
                    </div>
                </div>
            </div>

        </div>
         <div class="col-12 mb-4" v-if="available < 1">
            <p class="bg-primary border rounded-bottom font-weight-bold lead p-2 text-center text-black" >You have successfully registered all of your attendees!</p>
        </div>
        <div class="col-12 mb-4" v-else >
            <p class="bg-black border-left border-top border-right rounded-top lead p-2 text-center text-light text-primary mb-0">
                You have <strong style="font-size: x-large;">{{ available }}</strong> remaining passes available with your sponsorship.
            </p>
            <add-attendee-component  v-if="allowUpdates" :key="componentKey" :oh-available="ohAvailable"  :tx-available="txAvailable" :co-available="coAvailable" :available="available" :sponsorship="sponsorship"></add-attendee-component>
            <p v-else>
                Please email any changes or new additions to <a href="mailto:sponsorships@focus.org">sponsorships@focus.org</a>. The team will ensure all your additions and edits will be updated accordingly.
            </p>
        </div>
        <div class="col-12 mb-4">
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
    props: {
        sponsorship: Number,
        attendees: Array,
        available: Number,
        ohAvailable: Number,
        txAvailable: Number,
        coAvailable: Number,
        allowUpdates: Boolean
    },

    mounted() {
        // this.$store.dispatch('getAttendees', this.sponsorship)
        console.log(this.available)
    },
    computed: {
        ...mapState(['componentKey']),
    },

    methods: {
        remount() {
                this.$store.commit('SET_COMPONENT_KEY')
            },
        }
    }
</script>
<style scoped>
    .closer{
           font-size: 1.3em;
    }
    a.collapsed>.closer{
        display: none;
    }
    a:not(.collapsed)>.edit{
        display: none;
    }
</style>
